import { render, staticRenderFns } from "./BusinessOmniplayEventsPrestaSimple.vue?vue&type=template&id=1c758558"
import script from "./BusinessOmniplayEventsPrestaSimple.vue?vue&type=script&lang=js"
export * from "./BusinessOmniplayEventsPrestaSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports